import GroupNotificationTable from "../../components/Group/GroupNotification/GroupNotificationTable";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectGroupById } from "../../features/groups/groupSlice";
import NameHeading from "../../components/NameHeading";

const GroupNotificationsIndex = (): JSX.Element => {
  const { groupid } = useParams<{ groupid: string }>();
  const group = useAppSelector((state) => selectGroupById(state, groupid ?? ""));
  return (
    <>
      {group && <NameHeading name={group.name} />}
      <GroupNotificationTable />
    </>
  );
};

export default GroupNotificationsIndex;
